<script lang="ts">
    import {Check, HandThumbDown, MinusCircle} from "svelte-heros";
    import ButtonGroup from "../Elements/ButtonGroup.svelte";
    export let section: Section;
    export let index: number;

    const primary = section.blocks[0];
    const secondary = section.blocks[1];
    $: cta = section.cta.length > 0 ? section.cta[0] : null;
</script>

<div class="relative isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl" aria-hidden="true">
        <div class="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"></div>
    </div>
    <div class="mx-auto max-w-2xl text-center lg:max-w-4xl">
        {#if section.superTitle}
            <p class="text-base font-semibold leading-7 text-primary-500">{section.superTitle}</p>
        {/if}

        {#if index === 0}
            <h1 class="mt-2 text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl font-display">{section.title}</h1>
        {:else}
            <h2 class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl font-display">{section.title}</h2>
        {/if}
    </div>

    <p class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
        {section.subTitle}
    </p>

    <div class="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
        <div class="rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10 relative bg-white shadow-2xl">

            <h3 id="tier-personal" class="text-base font-semibold leading-7 text-primary-500">
                {primary.title}
            </h3>

            <p class="mt-6 text-base leading-7 text-gray-600">
                {primary.description}
            </p>

            <ul role="list" class="mt-8 space-y-3 text-sm leading-6 text-gray-600 sm:mt-10">
                {#each primary.bullets.split("\n") as bullet}
                    <li class="flex gap-x-3">
                        <Check class="h-6 w-5 flex-none text-primary-500" />
                        {bullet}
                    </li>
                {/each}
            </ul>

            {#if section.cta.length > 0}
                <div class="mt-8">
                    <ButtonGroup buttons={section.cta} />
                </div>
            {/if}
        </div>
        <div class="rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10 bg-white/60 sm:mx-8 lg:mx-0 sm:rounded-t-none lg:rounded-tr-3xl lg:rounded-bl-none">
            <h3 id="tier-team" class="text-base font-semibold leading-7 text-gray-600">{secondary.title}</h3>

            <p class="mt-6 text-base leading-7 text-gray-600">{secondary.description}</p>
            <ul role="list" class="mt-8 space-y-3 text-sm leading-6 text-gray-600 sm:mt-10">
                {#each secondary.bullets.split("\n") as bullet}
                    <li class="flex gap-x-3">
                        <MinusCircle class="h-6 w-5 flex-none text-primary-500" />
                        {bullet}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>
